<template>
  <div>
    <component-graph-renderer ref='graphRenderer'
                              class="w-full h-48"
                              :transforms-and-source='transformsAndSource'
                              :transform='{"id":"dummy"}'
                              :partutil='tmpPartutil'
                              :treeutil='treeutil'
                              @add='add'
                              @remove='remove'
                              >
        <template #editing='data'>
          <portal v-if='data.isSelectedComponent' to='component-edit-modal-after'>
            <pbc-modal title='' @done='$refs.graphRenderer.close({})' @close='$refs.graphRenderer.close({})' :enable-background='false'>
              <template #default=''>
                <component-details :component='data.component'
                  :transform='{"id":"dummy"}'
                  :transforms-and-source='transformsAndSource'
                  :partutil='tmpPartutil'
                  :is-selected-component='data.isSelectedComponent'
                  @add='add'
                  @remove='remove'>
                </component-details>

              </template>
              <template #controls='{close,done}'>
                <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
                  <pbc-button @click="done" ><check />Done</pbc-button>
                </div>
              </template>
            </pbc-modal>
          </portal>
        </template>
    </component-graph-renderer>

    <add-component-wizard-dialog v-if='addToComponent.id'
                                  :adding-to-parents='[addToComponent]'
                                  :adding-to-transforms='[{id:"dummy"}]'
                                  :partutil='tmpPartutil'
                                  :transforms-and-source='transformsAndSource'
                                  :component='component'
                                  :components='treeutil.components'
                                  :links='treeutil.links' 
                                  @close='onEditingClose'
                                  @add-components='addComponents'
                                  />
  </div>


</template>
<script>
import Treeutil from '@edit/tree/treeutil.js';
import Partutil from '@edit/tree/partutil.js';

import ComponentGraphRenderer from '@edit/organisms/ComponentGraphRenderer.vue';
import AddComponentWizardDialog from '@ui/organisms/AddComponentWizardDialog.vue';
import ComponentDetails from '@ui/molecules/ComponentDetails.vue';
import Check from '@icons/Check.vue';

export default {
  props:{
    transformsAndSource:{
      type: Object,
      required: true
    },
    component:{
      type:Object,
      required:true
    },
    components:{
      type:Array,
      required:true
    },
    links:{
      type:Array,
      required:true
    }
  },
  data() {
    const {components, links} = this;
    const treeutil = new Treeutil({components, links});
    const tmpPartutil = new Partutil({
      gamedata:this.transformsAndSource.gamedata,
      from:{
        links,
        components,
      }
    }); 

    return {
      treeutil,
      tmpPartutil,
      addToComponent:{}
    }
  },
  methods:{
    addComponents({addedComponents, addedLinks}) {
      this.$emit('added', {
        components:this.treeutil.components,
        links:this.treeutil.links
      });
    },
    add({component}) {
      this.addToComponent = component;
      //this.$refs.graphRenderer.refresh();
    },
    remove({component}) {
      const {removedComponents, removedLinks} = this.treeutil.removeComponent(component);
      console.log('emit remove');
      this.$emit('remove', {
        removedComponents,
        removedLinks,
      });
      //this._calculateComponentsAndLinks();
      
    },
    onEditingClose() {
      this.addToComponent = {};
    }
  },
  components:{
    ComponentGraphRenderer,
    AddComponentWizardDialog,
    ComponentDetails,
    Check
  }
}
</script>

